import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ModalOverlay from './ModalOverlay';
import Portal from '../Portal';
import Icon from '../Icons';

const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

const ModalContentWrapper = styled.div`
  position: relative;
  background-color: ${props => props.theme.carvana.white.primary};
  border-radius: 3px;
  box-shadow: 0 14px 21px rgba(24, 41, 61, 0.1);
  padding: ${props => (props.shouldHavePadding ? '20px' : 0)};
  top: 20px;

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    top: 0;
  }
`;

const TitleBar = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 44px;
  width: 100%;
  box-shadow: 0 2px 4px 1px rgba(25, 41, 61, 0.05);
  background-color: ${props => props.theme.carvana.white.primary};
  border-radius: 3px 3px 0px 0px;
  color: ${props => props.theme.carvana.blue.dark};
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 700;
`;

const CloseWrapper = styled.div`
  position: absolute;
  width: 14px;
  height: 14px;
  right: 14px;
  top: 14px;
  fill: ${props => props.theme.carvana.blue.dark};
  cursor: pointer;
`;

const InnerContentWrapper = styled.div`
  max-height: 88vh;
  max-width: 98vw;
  overflow-y: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 5px;
    background: ${props => props.theme.carvana.blue.pastel};
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${props => props.theme.carvana.blue.primary};
    border-radius: 4px;
    width: 5px;
  }
`;

class Modal extends PureComponent {
  static propTypes = {
    children: PropTypes.node.isRequired,
    onClose: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    className: PropTypes.string
  };

  constructor(props) {
    super(props);

    this.contentRef = React.createRef();
  }

  setContentRef = ref => {
    this.contentRef = ref;
  }

  render() {
    const { children, onClose, title, className } = this.props;

    return (
      <Portal>
        <ModalWrapper className={className}>
          <ModalOverlay contentRef={this.contentRef} onClick={onClose} />
          <ModalContentWrapper className={className}>
            <TitleBar>
              {title}
              <CloseWrapper data-cv="header-modal-close-btn" onClick={onClose}>
                <Icon iconName="close" />
              </CloseWrapper>
            </TitleBar>
            <InnerContentWrapper ref={this.setContentRef} className={className}>
              {children}
            </InnerContentWrapper>
          </ModalContentWrapper>
        </ModalWrapper>
      </Portal>
    );
  }
}

export default Modal;
